// override the browser's default fetch to globally trap 401's.
import * as types from "../constants/actionTypes";
import Cookies from "cookies-js";
import { adalGetToken } from '../helpers/react-adal/react-adal';
import { adalApiFetch } from '../adalConfig';


// adapted from https://www.npmjs.com/package/fetch-readablestream and https://javascript.info/fetch-progress
function getFromBodyReader(body) {
    const reader = body.getReader();
    const chunks = [];
    let receivedLength = 0;

    function pump() {
        return reader.read().then(({ value, done }) => {
            if (done) {
                let chunksAll = new Uint8Array(receivedLength);
                let position = 0;
                for (let chunk of chunks) {
                    chunksAll.set(chunk, position);
                    position += chunk.length;
                }
                const result = new TextDecoder("utf-8").decode(chunksAll);
                try {
                    return JSON.parse(result);
                }
                catch (e) {
                    return null;
                }
            }
            chunks.push(value);
            receivedLength += value.length;
            return pump();
        });
    }

    return pump();
}

const configureFetch = () => {
    const fetch = global.fetch;
    global.rawFetch = fetch;
    const newFetch = function (url, params) {
        if (url instanceof Request) {
            // unpack it here since Request has readonly properties
            //debugger;
            params = Object.assign(params || {}, {
                headers: url.headers,
                method: url.method,
                mode: url.mode,
                referrerPolicy: url.referrerPolicy,
                body: url.body,
                bodyUsed: url.bodyUsed,
                credentials: url.credentials,
                cache: url.cache,
                context: url.context
            });
            url = url.url;
        }
        else if (typeof params === "undefined" || params === null) {
            params = { method: "GET" };
        }

        params.mode = "cors";
        params.cache = "no-store";
        params.referrerPolicy = "unsafe-url";

        //let oState =  window && window.store && window.store.getState ? window.store.getState() : { domain: { c: null, s: null } };
        //let sCorrelationID = (oState && oState.domain ? oState.domain.c : null) || Cookies.get("bsw-CorrelationId");
        //let sSessionID = (oState && oState.domain ? oState.domain.s : null) || Cookies.get("bsw-SessionId");
        let domain = sessionStorage['root'] ? JSON.parse(JSON.parse(sessionStorage['root']).domain) : window && window.store && window.store.getState ? window.store.getState().domain : { c: null, s: null };
        let sCorrelationID = (domain ? domain.c : null) || Cookies.get("bsw-CorrelationId");
        let sSessionID = (domain ? domain.s : null) || Cookies.get("bsw-SessionId");
        params.headers = params.headers || {};

        if (sCorrelationID) {
            setHeaders(params.headers, "bsw-CorrelationId", sCorrelationID);
        }
        if (sSessionID) {
            setHeaders(params.headers, "bsw-SessionId", sSessionID);
        }

        if (url.indexOf("SummaryEx") > 0) {
            //debugger;
        }

        return fetch.apply(global, [url, params])
            .then(resp => {
                if (resp.status === 401) {
                    console.log("fetch 401");
                    //store.dispatch({ type: types.VERIFY_LOGIN });
                    return Promise.reject(new Error("Received 401 ResponseCode"));
                }
                if (resp.status === 409) {
                    return Promise.reject({ status: 409 });
                }
                if (resp.status === 404) {
                    return Promise.reject(resp);
                }
                return resp;
            }).catch(ExceptionResult => {
                return Promise.reject(ExceptionResult);
            });
    };
    global.fetchWithCreds = function (url, params) {
        if (url instanceof Request) {
            // unpack it here since Request has readonly properties
            //debugger;
            params = Object.assign(params || {}, {
                headers: url.headers,
                method: url.method,
                mode: url.mode,
                referrerPolicy: url.referrerPolicy,
                body: url.body,
                bodyUsed: url.bodyUsed,
                credentials: url.credentials,
                cache: url.cache,
                context: url.context
            });
            url = url.url;
        }
        else if (typeof params === "undefined" || params === null) {
            params = { method: "GET" };
        }
        params.credentials = "include";
        return newFetch(url, params);
    };
    global.fetch2 = (url, token, data, method, headers) => {
        const p = params(token, data, method, null, headers);
        return newFetch(url, p).then(response => {
            //debugger;
            if (response && response.url && response.url.toUpperCase().indexOf("DETAIL") > 0) {
                var sStophere = "Set a breakpoint";
            }

            const status = response.status;
            if (status >= 200 && status < 300) {
                if (status === 200) {//added this condition as fetch is failing in case of null response and status is 200:OK         
                    const contentType = response.headers.get('content-type');
                    if (contentType === null) {
                        return Promise.resolve('OK'); //given OK as of now.
                    }
                }
                else if (status === 204) {
                    const { body } = response;
                    if (response.statusText) {
                        return Promise.reject(response.statusText);
                    } else if (body && typeof body !== 'string' && typeof body.getReader !== 'undefined' && typeof TextDecoder !== 'undefined') {
                        return getFromBodyReader(body).then(response => {
                            console.log(response);
                            return Promise.reject(response);
                        });
                    }
                    else {
                        return Promise.resolve(null);
                    }
                }
                return Promise.resolve(response.json());
            } else {
                //debugger;
                return Promise.reject(response);
            }
        }).catch(err => {
            //debugger;
            const { body } = err;
            if (body && typeof body !== 'string' && typeof body.getReader !== 'undefined' && typeof TextDecoder !== 'undefined') {
                return getFromBodyReader(body).then(response => {
                    console.log(response);
                    return Promise.reject(response);
                });
            }
            else {
                console.log(err);
                return Promise.reject(err);
            }
        });
    };

    global.fetch = newFetch;


    global.fetchAdal = (url, options) => {
        //debugger;
        return adalApiFetch(global.fetch, url, options);
    };


};

const setHeaders = (header, headerKey, headerValue) => {
    if (header instanceof Headers) {
        header.set(headerKey, headerValue);
    }
    else {
        header[headerKey] = headerValue;
    }
};

global.params = function (token, data, method, contentType, headers) {
    let _params = {
        method: method ? method : 'get',
        headers: {
            'Content-Type': contentType ? contentType : 'application/json',
            'Cache-Control': 'no-cache'
        }
    };
    if (headers) {
        //debugger;
        _params.headers = Object.assign(_params.headers, headers);
        //debugger;
        //headers.forEach(function (header) { _params.headers.push(header) });
    }

    if (token) {
        _params.headers.Authorization = `bearer ${token}`;
    }

    if (data) {
        _params.body = data;
    }

    return _params;
};

global.urlParams = function () {
    var paramList = '';
    var delimiter = '?';
    for (var i = 0; i < arguments.length - 1; i = i + 2) {
        var arg = arguments[i + 1];
        if (arg !== undefined && arg !== null) {
            paramList += delimiter + arguments[i] + '=' + arg;
            delimiter = '&';
        }
    }
    return paramList;
};

export default configureFetch;
